import common from '../b2c/common-i18n';
import viewSiteContent from '../brawny/view-site-content-i18n';
import accessCustomerService from '../b2c/access-customer-service-i18n';
import nfr from '../b2c/nfr-i18n';
import searchBrowse from '../b2c/search-browse-i18n';

const messages = {
  'en-US': {
    accessCustomerService,
    // This below pdp section should come under one pdp.i18n
    pdpProductInfo: {
      findAStore: 'Where To Buy',
      findAStoreLabel: 'Brawny® can be found at a retailer near you',
      asmHeading: 'ASM Alert',
      asmMessage: 'Please click Start Session button to start guest session.',
    },
    pdpTabContainer: {
      tabDetails: 'Details',
      tabReviews: 'Reviews',
      tabRelatedProducts: 'Related Products',
    },
    pdp: {
      productDetails: {
        topLeftHeading: 'Product Overview',
        topRightHeading: 'Product Features',
        bottomHeading: 'Product Specifications',
      },
      relatedProductsTab: {
        topLeftHeading: 'Related Products',
      },
    },
    common,
    viewSiteContent,
    nfr,
    searchBrowse,
  },
};

export default messages;



// WEBPACK FOOTER //
// ./src/locale/brawny/messages.js